import { useEffect, useState } from 'react'

/** 画面が低くても表に確保する最小の縦幅。 */
const TABLE_MIN_HEIGHT = 240

/**
 * 取込モーダルの表（antd Table の scroll.y）に使う縦幅を、画面の高さから決める。
 * モーダルの枠は画面の高さいっぱいなので、表以外（モーダル枠・ステップ・案内・操作行・フッター）が
 * 使う縦幅の見込み reserved を引いた残りを全部表に回す。画面の大きさが変わったら追従する。
 */
export const useViewportTableHeight = (reserved: number): number => {
  const [height, setHeight] = useState(() =>
    Math.max(TABLE_MIN_HEIGHT, window.innerHeight - reserved)
  )
  useEffect(() => {
    const onResize = () =>
      setHeight(Math.max(TABLE_MIN_HEIGHT, window.innerHeight - reserved))
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [reserved])
  return height
}
